import React, { Component } from 'react';
import isEmpty from 'lodash.isempty';
import { withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

// helpers, endpoints
import { getItemWebUrl, queryString } from '/src/utilities/helpers';
import { WEB_URL } from '/src/utilities/endpoints';

// reusable components
import MagnittBanner from '/src/micro-frontends/MagnittBanner';
import NewsletterWidget from '/src/micro-frontends/NewsletterWidget';
import Mentions from './Mentions/Mentions';
import ContentImage from '/src/reusable-components/ContentImg';
import SearchWidget from '/src/micro-frontends/SearchWidget';
import TextFooter from '/src/reusable-components/TextFooter';
import RelatedArticles from '/src/widgets/RelatedArticles';

const ContentBody = loadable(() =>
    import(/* webpackChunkName: "ContentBody" */ '/src/reusable-components/ContentBody'),
);
const ContentTag = loadable(() =>
    import(/* webpackChunkName: "ContentTag" */ '/src/reusable-components/ContentTag'),
);
const SponsorFocus = loadable(() =>
    import(/* webpackChunkName: "SponsorFocus" */ '../Research/SponsorFocus'),
);



class SingleNews extends Component {

    constructor(props) {
        super(props);

        let newsData;
        if (__isBrowser__) {
            newsData = window.__INITIAL_DATA__.data;
        } else {
            newsData = props.staticContext.data;
        }

        this.state = {
            data: newsData,
            object: {},
            showSubscriptionModal: false,
            hasFundingTag:
                newsData.news_category_data &&
                newsData.news_category_data.filter((cat) => cat.name === 'Funding').length > 0,
            subscriptionModalShown: false,
        };
    }

    componentDidMount() {
        const parsedParams = queryString.parse(this.props.location.search);
        // subscription modal if has funding tag and not filtered query
        if (this.state.hasFundingTag) {
            if (
                parsedParams.utm_campaign === 'Amp' &&
                parsedParams.utm_medium === 'email' &&
                parsedParams.utm_source === 'insight'
            ) {
                this.setState({ showSubscriptionModal: false });
            } else {
                setTimeout(function () {
                    this.setState({ showSubscriptionModal: true, subscriptionModalShown: true });
                }.bind(this), 5000)
            }
        }
    }

    getNewsInitialData = () => {
        let object = this.state.data;
        let { metadesc, time, description } = '';
        let author = object.author ? object.author : 'MAGNiTT';
        let filePath = !isEmpty(object.image_data) && encodeURI(object.image_data.path);
        let objectUrl = getItemWebUrl('news', object.id, object.code);
        let socialTitle = object.title;

        if (object.body !== undefined && object.body !== null) {
            metadesc = object.body.replace(/<\/?[^>]+(>|$)/g, '');
            metadesc = metadesc.replace(/&nbsp;/g, ' ');
            metadesc = metadesc.replace(/&nbsp;/g, ' ');
            if (metadesc !== undefined && metadesc !== null && metadesc.length > 300) {
                description = metadesc.substr(0, 200);
                metadesc = metadesc.substr(0, 300);
                metadesc = metadesc.substr(0, metadesc.lastIndexOf(' ')) + ' ...';
                description = description.substr(0, description.lastIndexOf(' ')) + ' ...';
            }
        }

        if (object.published_at) {
            let date = new Date(object.published_at);
            let options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            };
            time = date.toLocaleString('en-US', options);
        }

        return {
            author,
            filePath,
            metadesc,
            object,
            objectUrl,
            socialTitle,
            time,
            description
        };
    };

    renderSubscribePopup() {
        const { showSubscriptionModal } = this.state;
        if (!showSubscriptionModal) {
            return null;
        }

        return (
            <div className="subscribe-modal">
                <div className="subscribe-modal__content">
                    <i
                        className="fas fa-times subscribe-modal__close"
                        onClick={() => {
                            this.setState((prev) => ({
                                ...prev,
                                showSubscriptionModal: !prev.showSubscriptionModal,
                            }));
                        }}
                    ></i>
                    <div className="subscribe-modal__inner-content">
                        <div className="subscribe-modal__image-container">
                            <div className="subscribe-modal__image" />
                            <div>
                                <h4 className="subscribe-modal__heading">
									Get the latest investment trends in your inbox!
                                </h4>
                                <p className="subscribe-modal__text">
									Our newsletters cover the latest insights and market research from VC ecosystems across emerging markets. Subscribe today!
                                </p>
                                <NewsletterWidget data={{ pageType: 'singlePageModal' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        const {
            author,
            filePath,
            metadesc,
            object,
            objectUrl,
            socialTitle,
            time,
            description
        } = this.getNewsInitialData();

        if (this.state.data === 404 || isEmpty(this.state.data) || this.state.data.id === null) {
            return <Redirect to="/not-found" />;
        }

        return (
            <div className="footer-margin-offset">
                <Helmet>
                    <title>{`${object.title} | MAGNiTT`}</title>
                    <link rel="canonical" href={`${WEB_URL}/${objectUrl}`} />
                    <link rel="preload" href={object?.preview_image_data?.path} as="image" fetchPriority='high'/>
                    <meta name="abstract" content={metadesc} />
                    <meta name="description" content={description} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content="@MAGNITT" />
                    <meta name="twitter:creator" content="@MAGNITT" />
                    <meta name="twitter:title" content={socialTitle} />
                    <meta name="twitter:description" content={description} />
                    <meta name="twitter:image" content={filePath} />
                    <meta name="twitter:image:alt" content={socialTitle} />
                    <meta property="og:description" content={metadesc} />
                    <meta property="og:author" content={author} />
                    <meta property="og:type" content="newsArticle" />
                    <meta property="og:headline" content={object.title} />
                    <meta property="og:image" content={filePath} />
                    <meta property="fb:app_id" content="206675253001485" />
                    <meta property="datePublished" content={time} />
                    <meta property="og:image:secure_url" content={filePath} />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "NewsArticle",
                            "publisher": {
                                "@type": "Organization",
                                "name": "MAGNiTT",
                                "logo": {
                                    "@type": "ImageObject",
                                    "url": "https://d2p9i44hnkrmkx.cloudfront.net/files/magnitt_magnitt_logo.jpg",
                                    "width": 600,
                                    "height": 400
                                }
                            },
                            "headline": object.title,
                            "mainEntityOfPage": {
                                "@type": "WebPage",
                                "@id": `${WEB_URL}/${objectUrl}`
                            },
                            "articleBody": metadesc,
                            "image": {
                                "@type": "ImageObject",
                                "url": filePath,
                                "height": 600,
                                "width": 400
                            },
                            "datePublished": object.published_at,
                            "dateModified": object.updated_at,
                            "author": {
                                "@type": "Person",
                                "name": author
                            }
                        })}
                    </script>
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "news",
                                "item": `${WEB_URL}/news`
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": object.title,
                                "item": `${WEB_URL}/${objectUrl}`
                            }]
                        })}
                    </script>
                </Helmet>

                {this.renderSubscribePopup()}

                <section className="directory content-box">
                    <div className="content-block">
                        <div className="row flex-grow-1">
                            <div className="column-full">

                                {/* <MagnittBanner data={{ match: this.props.match }} /> */}

                                {object && (
                                    <div className="mid-width-info-box">
                                        <div className="info-box-container">
                                            <div className="info-box-body content-body">

                                                <ContentImage
                                                    data={object}
                                                    socialTitle={socialTitle}
                                                    type="news"
                                                />

                                                <div className="page-header">

                                                    {/* title */}
                                                    <div className="article-title">
                                                        <h1>{object.title}</h1>
                                                    </div>

                                                    <div className="article-info-line">
                                                        <div className="article-info-with-divider">

                                                            {/* author */}
                                                            <span className="article-info-author">
                                                                {(author == 'Press Release' || author == 'The National') ? (
                                                                    <>Source: </>
                                                                ) : (
                                                                    <>Written by </>
                                                                )}
                                                                {author}
                                                            </span>

                                                            {/* posted time */}
                                                            <span className="article-info-date">
                                                                {time
                                                                    ? time
                                                                    : 'Unpublished'}
                                                            </span>

                                                            <ContentTag
                                                                tagdata={object}
                                                                type={'news'}
                                                            />

                                                        </div>
                                                    </div>

                                                    {object.sponsor_name && !isEmpty(object.sponsor_logo_data) && (
                                                        <div className="article-sponsor-line">
                                                            Sponsored by
                                                            {object.sponsor_name && (
                                                                <> {object.sponsor_name}</>
                                                            )}
                                                            <img
                                                                className="sponsored-logo"
                                                                src={object.sponsor_logo_data.path}
                                                                alt="Sponsored-Logo"
                                                            />
                                                        </div>
                                                    )}

                                                </div>

                                                <hr />

                                                <div className="row">

                                                    {/*
                                                      * hide these widgets on mobile
                                                      * as mobile version is integrated in the body content
                                                      */}
                                                    <div className="content-column-side hidden-lg-down">

                                                        {/* default widgets */}
                                                        <SearchWidget />

                                                        {/* custom widgets from admin panel */}
                                                        {/* the widgets are added through the ReactDOM.render function in ContentBody.js */}
                                                        <div id="custom-widgets-container"></div>

                                                        <NewsletterWidget
                                                            history={this.props.history}
                                                            data={{ pageType: "singleNews" }}
                                                        />

                                                        {/*
                                                          * sponsor focus
                                                          * not displayed on mobile/tablet to simplify the layout
                                                          */}
                                                        {object.sponsor_description && !isEmpty(object.sponsor_logo_data) && (
                                                            <SponsorFocus
                                                                img={object.sponsor_logo_data.path}
                                                                text={object.sponsor_description}
                                                                imgAlt='Sponsor-Logo'
                                                            />
                                                        )}

                                                    </div>
                                                    <div className="content-column-main">

                                                        <ContentBody
                                                            data={this.state.data}
                                                            history={this.props.history}
                                                            subscriptionModalShown={
                                                                this.state.subscriptionModalShown
                                                            }
                                                            user={this.props.user}
                                                            type="news"
                                                        />

                                                        <Mentions
                                                            id={this.state.data.id}
                                                            displayCount={10}
                                                        />

                                                    </div>
                                                </div>

                                                <TextFooter
                                                    image={filePath}
                                                    description={metadesc}
                                                    title={socialTitle}
                                                    url={`${WEB_URL}/${objectUrl}`}
                                                    data={this.state.data}
                                                />

                                                <RelatedArticles
                                                    displayCount={3}
                                                    itemId={this.state.data.id}
                                                    type="news"
                                                />

                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.userReducer,
});

export default withRouter(connect(mapStateToProps, {})(SingleNews));
